module.exports = __webpack_public_path__ + "static/media/soccer.525e4015.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/soccer.svg
// module id = 398
// module chunks = 7